import React from 'react';
import { View } from 'react-native';

import CustomText from '@atoms/CustomText';

import Verified from '../../../assets/svg/Verified';

import { styles } from './styles';

interface UserProfileInfoProps {
  fullName: string;
  userName: string;
  userType: 'PLAYER' | 'CREATOR';
  bio: string;
}

export const UserProfileInfo = ({ fullName, userName, userType, bio }: UserProfileInfoProps) => (
  <View style={styles.container}>
    <View style={styles.fullNameContainer}>
      <CustomText weight="interSemi" size="mlarge">
        {fullName}
      </CustomText>
      {userType === 'CREATOR' && <Verified />}
    </View>
    <View style={styles.typeContainer}>
      <CustomText color="purple" weight="interSemi">
        {`@${userName}`}
      </CustomText>
      <View style={styles.userType}>
        <CustomText customStyle={styles.userTypeText} weight="interMedium">
          {userType.toLocaleLowerCase()}
        </CustomText>
      </View>
    </View>
    {bio && (
      <CustomText customStyle={styles.bio} color="greySix" weight="interSemi">
        {bio}
      </CustomText>
    )}
  </View>
);
